import { GamePreviewProps } from "./GamePreview.types";
import GameActions from "./game-actions/GameActions";
import GameInfo from "./GameInfo";
import { Platform, ScrollView } from "react-native";
import GamePreviewInfo from "./GamePreviewInfo";

export default function GamePreview({ game }: GamePreviewProps) {
  return (
    <ScrollView
      style={{ marginTop: -16 }}
      contentContainerStyle={{
        paddingTop: 24,
        paddingBottom: Platform.OS !== "web" ? (game.attendees.length || 1) * 20 : 0,
      }}
      showsVerticalScrollIndicator={false}
    >
      <GamePreviewInfo game={game} />
      <GameActions game={game} />
      <GameInfo game={game} />
    </ScrollView>
  );
}
